import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions';
import { sendEditTeam, sendDeleteTeam } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class EditTeam extends React.Component {
    state = {
        name: "",
        customerID: null,
        teamID: null,
        confirm: false,
    }

    componentDidMount() {
        if (this.props.role === "ClientAdmin" && this.props.currentUser && this.props.currentUser.customerID) {
            let selectedCustomerId = this.props.currentUser.customerID
            this.setState({ customerID: selectedCustomerId })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.role === "ClientAdmin" && this.props.role !== prevProps.role && this.props.currentUser && this.props.currentUser.customerID) {
            let selectedCustomerId = this.props.currentUser.customerID
            this.setState({ customerID: selectedCustomerId })
        }
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.sendEditTeam(this.state.teamID, this.state.name, this.state.customerID)
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: parseInt(event.target.value) })
    }

    handleTeam = (event) => {
        event.preventDefault()
        this.setState({ teamID: parseInt(event.target.value) })
    }

    handleName = (event) => {
        event.preventDefault()
        this.setState({ name: event.target.value })
    }

    handleDeleteTeam = () => {
        if (this.state.teamID === null) {
            return (<div className='rightButton'><button className="btn" > Delete Team</button></div>)
        } else if (this.state.confirm === false) {
            return (<div className='rightButton'><button className="btn" onClick={this.handleDelete}  id="deleteteam_btn" > Delete Team</button></div>)
        } else {
            return (<div className='rightButton'><button className="btn" onClick={this.handleDelete}  id="confirmdeleteteam_btn">Confirm Delete</button></div>)
        }
    }

    handleDelete = () => {
        if (this.state.confirm === false) {
            this.setState({ confirm: true })
        } else {
            this.props.sendDeleteTeam(this.state.teamID)
        }
    }

    handleCheckBoxes = (event) => {
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }


    populateCustomers = () => {
        let selectedCustomerId = this.props.currentUser.customerID

        if (this.props.role === "IEAdmin") {
            return (
                <Select
                    className="myInput"
                    defaultValue=""
                    onChange={this.handleCustomerID}
                    value={this.state.customerID !== null ? this.state.customerID : ""}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select Customer</MenuItem>
                    {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                </Select>
            )
        } else {
            return (
                <Select
                    className="myInput"
                    defaultValue=""
                    onChange={() => {}}
                    value={selectedCustomerId}
                    disabled={true}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select Customer</MenuItem>
                    {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                </Select>
            )
        }
    }

    populateTeams = () => {
        if (this.state.customerID !== null) {
            return (
                <Select
                    className="myInput"
                    defaultValue=""
                    onChange={this.handleTeam}
                    value={this.state.teamID}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select Team</MenuItem>

                    {this.props.teamList.filter(y => y.customer.id === this.state.customerID).map((x) => x && <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                </Select>
            )
        } else {
            return (<div />)
        }
    }

    render() {
        return (
            <>
                <>
                    <Dialog
                        open={true}
                        onClose={this.handleClick}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <CloseIcon onClick={this.handleClick} className="closePoup" />
                        <DialogTitle id="alert-dialog-title" className="changepassdialog">
                            Edit Team
                        </DialogTitle>
                        <DialogContent>
                            <form className="form" onSubmit={this.handleSubmit} >
                                <div className="myInputOut">
                                    <input
                                        type="text"
                                        className="myInput"
                                        onChange={this.handleName}
                                        value={this.state.name}
                                        placeholder="Team Name"
                                        required
                                    />
                                </div>
                                <div className="adminSelectbox">
                                    <label className="mainLable">Customer:</label>
                                    <div className="myInputOut">
                                        {this.populateCustomers()}
                                    </div>

                                    <label className="mainLable">Existing Team:</label>
                                    <div className="myInputOut">
                                        {this.populateTeams()}
                                    </div>
                                </div>
                                <button className="btn" type="submit" value="Submit" id="submit_btn">
                                    Submit
                            </button>
                                {this.handleDeleteTeam()}
                            </form>
                            </DialogContent>
                    </Dialog>
                </>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        userList: state.users.data,
        customerList: state.users.customerList,
        teamList: state.users.teamList,
        role: state.users.role,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, sendEditTeam, sendDeleteTeam }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTeam)